define([
    "./monitoringNodeCommandsModule"
], function (module) {
    "use strict";

    return module.service("nodeCommandMonitorableCancel", ["monitorableService", function (monitorableService) {
        return function (selection, context) {
            return monitorableService.cancelMonitorables(selection.map(function (nodeIdentifier) {
                return nodeIdentifier.id;
            })).then(function () {
                return context.refilter();
            });
        };
    }]);
});